import * as XLSX from 'xlsx';

/**
 * Export Sales Achievement data to Excel
 * @param {Array} filteredData - Filtered sales data
 * @param {Function} showAlert - Alert function
 */
export const exportSalesAchievement = (filteredData, showAlert) => {
    try {
        const dataToExport = filteredData.map(row => ({
            'NAMA SALES': row.name || '',
            'JUMLAH INVOICE': row.invoiceCount || 0,
            'SUB TOTAL': row.subtotal || 0,
            'PPN': row.ppn || 0,
            'AKUMULASI NILAI (IDR)': row.totalValue || 0,
            'KONTRIBUSI': row.contribution ? `${row.contribution.toFixed(1)}%` : '0.0%'
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sales Achievement');

        // Set column widths
        const columnWidths = [
            { wch: 25 }, // NAMA SALES
            { wch: 18 }, // JUMLAH INVOICE
            { wch: 20 }, // SUB TOTAL
            { wch: 15 }, // PPN
            { wch: 25 }, // AKUMULASI NILAI
            { wch: 15 }  // KONTRIBUSI
        ];
        ws['!cols'] = columnWidths;

        XLSX.writeFile(wb, `Sales_Report_${new Date().toISOString().split('T')[0]}.xlsx`);
        showAlert('success', 'Sales report exported successfully!');
    } catch (error) {
        console.error('Error exporting to Excel:', error);
        showAlert('danger', 'Failed to export sales report');
    }
};

/**
 * Export Sales by Service Item data to Excel
 * @param {Array} filteredServiceItemData - Filtered service item data
 * @param {Function} showAlert - Alert function
 */
export const exportSalesByServiceItem = (filteredServiceItemData, showAlert) => {
    try {
        const dataToExport = filteredServiceItemData.map(row => ({
            'SERVICE ITEMS': row.serviceItem || '',
            'STANDARD': row.standard || '',
            'QTY. TERJUAL': row.qtyTerjual || 0,
            'TOTAL REVENUE': row.totalRevenue || 0,
            'TOTAL MANDAYS': row.totalMandays || 0,
            'AVG. RATE/MANDAY': row.avgRateManday || 0
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sales by Service Item');

        // Set column widths
        const columnWidths = [
            { wch: 25 }, // SERVICE ITEMS
            { wch: 30 }, // STANDARD
            { wch: 15 }, // QTY. TERJUAL
            { wch: 20 }, // TOTAL REVENUE
            { wch: 15 }, // TOTAL MANDAYS
            { wch: 20 }  // AVG. RATE/MANDAY
        ];
        ws['!cols'] = columnWidths;

        XLSX.writeFile(wb, `Sales_By_Service_Item_${new Date().toISOString().split('T')[0]}.xlsx`);
        showAlert('success', 'Sales by Service Item report exported successfully!');
    } catch (error) {
        console.error('Error exporting to Excel:', error);
        showAlert('danger', 'Failed to export sales by service item report');
    }
};

/**
 * Export Customer Balance data to Excel
 * @param {Array} filteredCustomerBalanceData - Filtered customer balance data
 * @param {Function} showAlert - Alert function
 */
export const exportCustomerBalance = (filteredCustomerBalanceData, showAlert) => {
    try {
        const dataToExport = filteredCustomerBalanceData.map(row => ({
            'NAMA PELANGGAN': row.customerName || '',
            'TOTAL TAGIHAN (IDR)': row.totalTagihan || 0,
            'TOTAL TERBAYAR (IDR)': row.totalTerbayar || 0,
            'SISA PIUTANG (IDR)': row.sisaPiutang || 0,
            'STATUS': row.status || ''
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Customer Balance');

        // Set column widths
        const columnWidths = [
            { wch: 25 }, // NAMA PELANGGAN
            { wch: 25 }, // TOTAL TAGIHAN
            { wch: 25 }, // TOTAL TERBAYAR
            { wch: 25 }, // SISA PIUTANG
            { wch: 20 }  // STATUS
        ];
        ws['!cols'] = columnWidths;

        XLSX.writeFile(wb, `Customer_Balance_${new Date().toISOString().split('T')[0]}.xlsx`);
        showAlert('success', 'Customer Balance report exported successfully!');
    } catch (error) {
        console.error('Error exporting to Excel:', error);
        showAlert('danger', 'Failed to export customer balance report');
    }
};

/**
 * Export Sales List Detail data to Excel
 * @param {Array} filteredSalesListDetailData - Filtered sales list detail data
 * @param {Function} showAlert - Alert function
 */
export const exportSalesListDetail = (filteredSalesListDetailData, showAlert) => {
    try {
        const dataToExport = filteredSalesListDetailData.map(row => ({
            'INVOICE ID': row.invoiceId || '',
            'TANGGAL': row.tanggal || '',
            'PELANGGAN': row.pelanggan || '',
            'SALES CREATOR': row.salesCreator || '',
            'NILAI INVOICE (IDR)': row.nilaiInvoice || 0,
            'STATUS BAYAR': row.statusBayar || ''
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sales List Detail');

        // Set column widths
        const columnWidths = [
            { wch: 15 }, // INVOICE ID
            { wch: 15 }, // TANGGAL
            { wch: 25 }, // PELANGGAN
            { wch: 20 }, // SALES CREATOR
            { wch: 20 }, // NILAI INVOICE
            { wch: 15 }  // STATUS BAYAR
        ];
        ws['!cols'] = columnWidths;

        XLSX.writeFile(wb, `Sales_List_Detail_${new Date().toISOString().split('T')[0]}.xlsx`);
        showAlert('success', 'Sales List Detail report exported successfully!');
    } catch (error) {
        console.error('Error exporting to Excel:', error);
        showAlert('danger', 'Failed to export sales list detail report');
    }
};

